import { CoreRequest } from '../../../../infrastructure';

export default async function VendorUpdate(requestUrl, content = {}) {
    const execute = async (requestUrl, body = {}) => {
        const req = {
            requestUrl,
            body
        };
        const response = await CoreRequest(req);

        return response.json();
    };

    try {
        return execute(requestUrl, content);
    } catch (error) {
        console.error('Error handler', error);
        throw new Error(`lookup failed: ${error}`);
    }
}
